import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "upv_session_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: `${BACKEND}/api`, timeout: 30000 });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 401 && getToken() && !String(err.config?.url || "").includes("/auth/login")) {
    setToken(null);
    window.dispatchEvent(new Event("upv-session-expired"));
  }
  return Promise.reject(err);
});

/** Human readable message + optional per-field errors from a FastAPI error. */
export function apiError(err, fallback = "Se ha producido un error. Inténtalo de nuevo.") {
  const d = err?.response?.data?.detail;
  if (!err?.response) return { message: "Sin conexión con el servidor. Revisa tu red e inténtalo de nuevo.", fields: {} };
  if (typeof d === "string") return { message: d, fields: {} };
  if (d && typeof d === "object" && !Array.isArray(d)) return { message: d.message || fallback, fields: d.fields || {} };
  if (Array.isArray(d)) return { message: "Revisa los campos marcados", fields: Object.fromEntries(d.map((x) => [x.loc?.[x.loc.length - 1], "Valor no válido"])) };
  return { message: fallback, fields: {} };
}

/** Images may be static frontend paths or backend file URLs. */
export const assetUrl = (p) => (p && p.startsWith("/api/") ? `${BACKEND}${p}` : p);

/** Fetch an authenticated binary (CV, receipt) and return an object URL. */
export async function fetchBlobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

/** Native browser download through a short-lived signed URL returned by the API. */
export function openDownload(url) {
  const a = document.createElement("a");
  a.href = `${BACKEND}${url}`;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
